import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';

import { VeloAssistantButton } from '#client/components/VeloAssistantButton';

const FloatingContainer = superstyled({
  name: 'FloatingVeloButtonContainer',
  tag: Box,
  styles: () => ({
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: 1000,
    backgroundColor: '#FFFFFF',
    borderRadius: '50%',
    // Ensure it doesn't interfere with interactions
    pointerEvents: 'none',
    '& > *': {
      pointerEvents: 'auto'
    }
  })
});

const FloatingVeloButton = () => (
  <FloatingContainer>
    <VeloAssistantButton
      variant="outlined"
      color="primary"
      avatarColor="#FAFAFA"
      iconOnly
      clickstreamProps={{
        elementName: 'floating_velo_assistant_button',
        elementPosition: 'bottom_right_floating'
      }}
    />
  </FloatingContainer>
);

export default FloatingVeloButton;
